import { createContext, ReactNode, useContext } from "react";

import { useFilterClient } from "./filter-client.hook";

const FilterClientContext = createContext(
  {} as ReturnType<typeof useFilterClient>
);
export function useFilterClientContext() {
  return useContext(FilterClientContext);
}

interface FilterClientProviderProps {
  children: ReactNode;
}
export function FilterClientProvider({
  children,
}: FilterClientProviderProps) {
  return (
    <FilterClientContext.Provider value={useFilterClient()}>
      {children}
    </FilterClientContext.Provider>
  );
}